// extracted by mini-css-extract-plugin
export var black = "_i-6";
export var brand = "_i-1";
export var ddefault = "_i-0";
export var error = "_i-3";
export var gray = "_i-2";
export var highContrast = "_i-8";
export var outline = "_i-7";
export var success = "_i-5";
export var warning = "_i-4";